import 'slick-carousel';
import RoomCardSlider from './room-card-slider.js';

document.querySelectorAll('.js-room-card__slider').forEach(elem => {
  new RoomCardSlider(elem);
});